module.exports = __webpack_public_path__ + "img/top side seam.5c92e40f.png";